import { render, staticRenderFns } from "./komchat-pricing-modal.vue?vue&type=template&id=60147591&"
import script from "./komchat-pricing-modal.vue?vue&type=script&lang=js&"
export * from "./komchat-pricing-modal.vue?vue&type=script&lang=js&"
import style0 from "./komchat-pricing-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports